const supportExcerptBlocksMotion = () => {
  const components = document.querySelectorAll('[data-component-support-excerpt-blocks]');
  components.forEach((component) => {
 /*   const timeline = gsap.timeline({paused: true});
    timeline.fromTo(component, {
      opacity: 0,
    }, {
      opacity: 1,
      ease: 'power3.out',
      duration: 0.5,
    });

    setupComponentScrollTrigger(component, timeline);
    */
  });

  ScrollReveal().reveal('.support-excerpt-blocks', { origin: 'bottom', distance: '300px', delay: 1200  });
};

supportExcerptBlocksMotion();